import React from 'react';
import styled from 'styled-components';
import { BannerAdZoneIdMap } from './ads-zone-id-map';
import { AdsBannerInsTag } from './ads-banner-ins-tag';
import { useRouteMatchPath } from '../../router/utils';
import { useTranslation } from 'react-i18next';
import { isCasperWalletMobileIOS } from '../../utils/user-agent';

export const UndergroundContainer = styled.span<{
  background: string | undefined;
}>(({ theme, background }) =>
  theme.withMedia({
    display: 'inline-block',
    backgroundImage: background,
    backgroundRepeat: 'no-repeat',
    border: '1px solid transparent',
    borderRadius: '6px',

    ...(background && { cursor: 'pointer' }),

    img: {
      border: '0px solid transparent',
      borderRadius: '6px',
    },
  })
);

export const DesktopUndergroundContainer = styled(UndergroundContainer)(
  ({ theme }) =>
    theme.withMedia({
      width: '300px',
      height: '100px',
      margin: '0',
      backgroundSize: '300px 100px',
    })
);

export const TabletUndergroundContainer = styled(UndergroundContainer)(
  ({ theme }) =>
    theme.withMedia({
      width: '728px',
      height: '90px',
      backgroundSize: '728px 90px',
    })
);

export const MobileUndergroundContainer = styled(UndergroundContainer)(
  ({ theme }) =>
    theme.withMedia({
      width: '300px',
      height: '100px',
      backgroundSize: '300px 100px',
    })
);

const UndergroundAdsBannerContainer = ({ children, variation }) => {
  const { t } = useTranslation();
  const onPlaceholderClick = () => {
    const hasInsTagWithLink = document.querySelector('ins > a');

    if (
      !(hasInsTagWithLink && hasInsTagWithLink.hasAttribute('href')) &&
      !isCasperWalletMobileIOS()
    ) {
      window.open('https://cspr.name/', '_blank', 'noopener');
    }
  };

  const getBackgroundContainerByVariation = () => {
    switch (variation) {
      case 'short':
        return (
          <MobileUndergroundContainer
            background={`url('https://casper-assets.s3.us-east-1.amazonaws.com/banners/banner-placeholder-300.webp')`}
            onClick={onPlaceholderClick}
            role="img"
            aria-label={t('CSPR.live ads container')}
          >
            {children}
          </MobileUndergroundContainer>
        );
      case 'long':
        return (
          <TabletUndergroundContainer
            background={`url('https://casper-assets.s3.us-east-1.amazonaws.com/banners/banner-placeholder-728.webp')`}
            onClick={onPlaceholderClick}
            role="img"
            aria-label={t('CSPR.live ads container')}
          >
            {children}
          </TabletUndergroundContainer>
        );
      default:
        return (
          <DesktopUndergroundContainer
            background={`url('https://casper-assets.s3.us-east-1.amazonaws.com/banners/banner-placeholder-300.webp')`}
            onClick={onPlaceholderClick}
            role="img"
            aria-label={t('CSPR.live ads container')}
          >
            {children}
          </DesktopUndergroundContainer>
        );
    }
  };

  return getBackgroundContainerByVariation();
};

const AdsBanner = ({ variation }: { variation?: string }) => {
  const match = useRouteMatchPath();
  const pathname = match.path;

  const networkName = config.network_name;
  const env = config.environment_name;
  const envByNetworkVersion = networkName === 'dev-net' ? 'testnet' : env;

  const zonesIdsByPage = BannerAdZoneIdMap[pathname];
  const zoneId = zonesIdsByPage
    ? zonesIdsByPage[variation][envByNetworkVersion]
    : null;

  return zoneId ? (
    <UndergroundAdsBannerContainer variation={variation}>
      <AdsBannerInsTag zoneId={zoneId} />
    </UndergroundAdsBannerContainer>
  ) : null;
};

export default AdsBanner;
